import { trackAnalytics } from "services/analytics";

export const faOnSearchLoad = (variant) => {
    trackAnalytics({
        eVar0: `b2b|aeh|search|landing${variant? `|${variant}`: "" }`,
    });
};

export const faOnSearchClick = (variant) => {
    trackAnalytics({
        eVar9: `b2b|aeh|search${variant? `|${variant}`: ""}`,
    });
}

export const faOnSearchSuccess = ({ type, search, searchQuery }) => {
    trackAnalytics({
        eVar9: `b2b|aeh|search|${type.toLowerCase()}`,
        eVar34: search,
        eVar35: searchQuery,
    });
};

export const faOnLoadMoreClick = ({ searchQuery }) => {
    trackAnalytics({
        eVar9: `b2b|aeh|search|load more`,
        eVar35: searchQuery,
    });
};

export const faOnIncompleteSearch = ({ searchQuery }) => {
    trackAnalytics({
        eVar9: `b2b|aeh|search|incomplete`,
        eVar35: searchQuery,
    });
};

export const faOnNoSearchResult = ({ searchQuery }) => {
    trackAnalytics({
        eVar9: `b2b|aeh|search|result not found`,
        eVar35: searchQuery,
    });
};

export const faOnFeedbackClick = () => {
    trackAnalytics({
        eVar9: `b2b|aeh|search|feedback`,
    });
};
